// extracted by mini-css-extract-plugin
export var button = "style-module--button--oGTlR";
export var full = "style-module--full--t5O4V";
export var outlined = "style-module--outlined--eomTI";
export var transparent = "style-module--transparent--YRUpo";
export var white = "style-module--white--NY0Si";
export var content = "style-module--content--RTQb0";
export var contentText = "style-module--contentText--SbYBW";